import { useRecoilState } from "recoil";
import { mostraListaSeries } from "../atom";

const useMostraListaSeries = () => {
    return useRecoilState(mostraListaSeries);
};
export default useMostraListaSeries;